<template>
	<div>
		<div class="modal-header">
		    <div class="modal-title">
		        <a-icon type="medicine-box" style="margin-right:10px" />
		        <span>{{l('Batch_Change_Reviewer')}}</span>
		    </div>
		</div>
		<div>
		    <a-config-provider :locale="antdLocale">
				<a-row>
				    <a-col :span="24" style="text-align: center;">
						<a-select showSearch :filterOption="filterOption" style="width: 200px;" dropdownClassName="drop-down-Style"
                      :dropdownMatchSelectWidth="false" :placeholder="l('please_select_reviewer')"
                      allow-clear v-model="inspectorId">
							<a-select-option v-for="item in AllLPAUser" :key="item.id" :title="item.name">
							  {{ item.realName }}
							</a-select-option>
						</a-select>
					</a-col>
				</a-row>
			</a-config-provider>
		</div>
		<div class="modal-footer" v-if="!isLook">
		    <a-button @click="close">
		        {{l('Cancel')}}
		    </a-button>
		    <a-button :type="'primary'" @click="save">
		        {{l('Save')}}
		    </a-button>
		</div>
	</div>
</template>

<script>
	import ModalComponentBase from '../../../../shared/component-base/modal-component-base';
	import zh_CN from 'ant-design-vue/lib/locale/zh_CN';
	import { IssueServiceProxy, AuditTaskServiceProxy} from '../../../../shared/service-proxies';
	
	let _this;
	export default {
		name: 'assign',
		mixins: [ModalComponentBase],
		components: {
		    
		},
		created() {
		    this.fullData(); // 模态框必须,填充数据到data字段
		    this.IssueServiceProxy = new IssueServiceProxy(this.$apiUrl, this.$api);
			  this.AuditTaskServiceProxy = new AuditTaskServiceProxy(this.$apiUrl, this.$api);
		},
		mounted() {
			this.getData();
		},
		data() {
		    return {
				  zh_CN,
          isLook: false,//是否是查看
				  ids: [],
          AllLPAUser: [],
          inspectorId:undefined,
		    }
		},
		methods: {
			getData() {
				this.isLoading = true;
        this.AuditTaskServiceProxy.getAllLPAUsers(
        )
            .finally(() => {
              this.isLoading = false;
            })
            .then((res) => {
              console.log(res);
              this.AllLPAUser = res;
            })
			},
			// workProcessClassChange(value){
			// 	console.log(value.key);
			// 	this.user = value.key;
			// },
			filterOption(input, option){
			    return (
			        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
			    );
			},
			save() {
				if (this.inspectorId==undefined) {
				    abp.message.info(this.l("please_select_reviewer"));
				    return;
				}

        this.$confirm(
            {
              title: this.l("Change_the_reviewer"),
              content: this.l("Have_you_confirmed_the_change_of_reviewer"),
              cancelText: this.l('Cancel'),
              okText: this.l('Ok'),
              onOk: () => {
                this.isLoading = true;
                this.AuditTaskServiceProxy.batchUpdateInspector(this.inspectorId,this.ids).then(res => {
                  this.isLoading = false;
                  this.getData();
                  this.selectedRowKey = [];
                  this.$notification["success"]({
                    message: this.l("Change_successful"),
                  });
                  this.success(true);
                })
              }
            })
			},
			
		}
	}
</script>

<style>
</style>
